import styled from 'styled-components'
import { colorTheme } from '../../../style/theme/colorTheme'

export const WatchIconButton = styled.button`
	display: flex;
	font-size: 1rem;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 3.31em;
	min-height: 2.69em;
	border: 1px solid transparent;
	border-radius: 0.75em;
	cursor: pointer;
	flex-shrink: 0;
	border: 1px solid ${colorTheme.button.type.primary};
	color: ${colorTheme.watch.button.icon};
	background-color: ${colorTheme.watch.button.idleBackground};
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0px 0px 0px 2px ${colorTheme.button.type.borderHover}, 0px 6px 6px 0px rgba(0, 0, 0, 0.25);
	}

	> svg {
		width: 1.44em;
		height: 2.06em;
	}

	&.connected {
		border-color: ${colorTheme.watch.button.connectedBorder};
		background-color: ${colorTheme.watch.button.connectedBackground};
	}
`
WatchIconButton.displayName = 'WatchIconButton'

export const WatchConnectedDot = styled.span`
	position: absolute;
	top: 0.25em;
	right: 0.25em;
	width: 0.63em;
	height: 0.63em;
	border-radius: 50%;
	background-color: ${colorTheme.watch.button.dot};
`
WatchConnectedDot.displayName = 'WatchConnectedDot'
